<div class="body_container">
  <h4>Application List</h4>
  <table class="table  main-panel-table">
    <thead>
      <tr class="table-list-head">
        <th scope="col" width="6%">#</th>
        <th scope="col" width="34%">
          Deployment
          <span style="cursor: pointer" [ngClass]="
                  sortDeployment == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByDeployment()">
          </span>
        </th>
        <th scope="col" width="30%">
          No. of Applications
          <span style="cursor: pointer" [ngClass]="
                  sortNoOfApps == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByNoOfApps()">
          </span>
        </th>
        <th scope="col" width="30%">
          Infrastructure
          <span style="cursor: pointer" [ngClass]="
                  sortInfra == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                class="bi" (click)="sortByInfrastructure()">
          </span>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!dataEmpty">
      <tr class="table-list-row" *ngFor="let dep of deployments | paginate: { itemsPerPage: 10, currentPage: p }; let i = index"
          (click)="redirectTo(dep)"
          style="cursor: pointer">
        <td scope="row" *ngIf="p == 1">{{ i + 1 }}</td>
        <td scope="row" *ngIf="p != 1">
          {{ (p - 1) * 10 + (i + 1) }}
        </td>
        <td class="impListName">{{ dep.name }}</td>
        <td>{{ dep.totalApplications }}</td>
        <td>{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  dep.cloud + ": VDI" : dep.cloud}}</td>
      </tr>
    </tbody>
  </table>
  <pagination-controls *ngIf="deployments"
                       class="my-pagination ms-auto"
                       (pageChange)="p = $event">
  </pagination-controls>
  <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%">
    No Deployment Available.
  </p>
  <ngx-spinner *ngIf="toShow !== true"
               bdColor="rgba(0,0,0,0)"
               size="default"
               zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
